// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Heass","content":"GlobalSearch_content__YxcqH"};